import React, { useEffect, useState } from "react";
import {
    Button,
    Drawer,
    makeStyles
} from "@material-ui/core";
import { connect } from "react-redux";
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import FuelBunk from "../../../assets/diesel-card-fuel-bunk.png";
import RelianceLogo from "../../../assets/reliance-icon-large.png";
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot
} from '@material-ui/lab';
import {
    updateChatView
} from "../../../store/actions/userActionCreators";

const useStyles = makeStyles((theme) => ({

    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    paperDrawer: {
        width: 427,
        maxWidth: 427,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    divTitle: {
        fontWeight: 600,
        fontSize: 18,
        color: '#0b1323'
    },
    tryButton: {
        backgroundColor: '#0033cc',
        color: 'white',
        borderRadius: 8,
        boxShadow: 'none !important',
        textTransform: 'none !important',
        paddingTop: 16,
        paddingBottom: 16,
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    timeLineV1: {
        padding: '0px !important',
        margin: '0px !important'
    },
    timeLineItemRoot: {
        minHeight: 'fit-content'
    },
    missingOppositeContentV1: {
        '&:before': {
            flex: 'inherit',
            content: 'none',
            padding: '0px !important'
        }
    },
    rootDotSuccessful: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 18,
        backgroundColor: '#24ad31',
        boxShadow: 'none !important'
    },
    contentRootV1: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingBottom: '0px !important',
        paddingTop: '0px !important',
        marginTop: '0px',
        height: 'fit-content',
        textAlign: 'left',
        fontSize: 16,
        fontWeight: 600
    },
    dialogContent: {
        backgroundColor: '#f6f6f8 !important',
        paddingLeft: 60,
        paddingRight: 60,
        paddingTop: 42,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    dialogTitle: {
        paddingBottom: '12px !important',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08) !important'
    },
    rootDotSuccessfull: {
        width: '40px',
        height: '40px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 16,
        backgroundColor: '#179c6d',
        color: 'white',
        boxShadow: 'none !important'
    },
    timeLineConnectorRoot: {
        backgroundColor: '#d1d3d8',
        height: '44px'
    },
    mbV1: {
        marginBottom: '6em'
    }


}))

const DieselCardEducation = ({ rightSideBarOpen, onClose, dispatchChatView, user }) => {

    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {

        dispatchChatView(false);

        setTimeout(() => {
            if (rightSideBarOpen) {
                setDialogOpen(true)
            }
        }, 200)

    }, [rightSideBarOpen]);

    const classes = useStyles()

    const handleClose = () => {
        dispatchChatView(true);
        setDialogOpen(false)
        onClose()
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.paperDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-"} siderBarType={'truckBook'} onClose={handleClose} className={classes.dialogTitle}>
                    <div className={classes.divTitle}>
                        Online Fuel Recharge
                    </div>
                </SideBarDialogTitle>

                <SideBarDialogContent className={classes.dialogContent} dividers>
                    <div>
                        <div><img src={FuelBunk} /></div>

                        <div>
                            <Timeline className={classes.timeLineV1}>
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotSuccessfull }}>
                                            1
                                        </TimelineDot>
                                        <TimelineConnector classes={{ root: classes.timeLineConnectorRoot }} />
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        Recharge your Fuel account Online
                                    </TimelineContent>
                                </TimelineItem>
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotSuccessfull }}>
                                            2
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        Driver fills Diesel in any Reliance Petrol Bunk using OTP
                                    </TimelineContent>
                                </TimelineItem>
                            </Timeline>
                        </div>
                    </div>

                    <div className={classes.mbV1}>
                        <img src={RelianceLogo} />
                    </div>
                </SideBarDialogContent>


                <SideBarDialogActions>
                    <Button variant="contained" fullWidth className={classes.tryButton} onClick={handleClose}>
                        Try it now
                    </Button>
                </SideBarDialogActions>

            </Drawer>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DieselCardEducation);
